import { types } from "../actions";

const initialState = {
   cvAppList: []
};

const cvAppReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCHED_CV_APP: {
        return {
            ...state,
            cvAppList: action.payload
        }
    }
    
    default:
      return state;
  }
};
export default cvAppReducer;